import YouTubeLiteEmbed from './youtube-lite-embed.mjs';

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-youtube-id]').forEach((element) => {
    new YouTubeLiteEmbed(element);
  });
});

